import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';
import primaLogo from '../aseets/images/prima_logo.png';
import { Link, NavLink } from 'react-router-dom';
import { getPartners, getFileUrl } from '../services/apiService';

const About = () => {
  const { t } = useTranslation();
  const [partners, setPartners] = useState([]);
  const [partnersLoading, setPartnersLoading] = useState(true);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        setPartnersLoading(true);
        const data = await getPartners();
        setPartners(data || []);
      } catch (err) {
        console.error('Error fetching partners:', err);
        setPartners([]);
      } finally {
        setPartnersLoading(false);
      }
    };
    fetchPartners();
  }, []);

  return (
    <>
      <style>{`
        @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        .fade-up { animation: fadeUp .8s ease both; }
        
        @media (max-width: 768px) {
          .about-hero-content { padding: 20px !important; }
          .about-stats { 
            flex-direction: row !important; 
            gap: 12px !important; 
            flex-wrap: wrap !important;
            justify-content: center !important;
          }
          
          /* Sections padding reduction */
          .about-section,
          .main-outcomes-section,
          .innovation-section,
          .objectives-section {
            padding: 40px 15px !important;
          }
          
          /* CTA Band mobile */
          .about-cta-band {
            padding: 20px 15px !important;
          }
          .about-cta-container {
            flex-direction: column !important;
            text-align: center !important;
            gap: 12px !important;
          }
          .about-cta-band strong {
            font-size: 16px !important;
            display: block;
            margin-bottom: 8px;
          }
          .about-cta-band a {
            width: 100%;
            text-align: center;
            display: block;
          }
          
          /* Hero image height mobile */
          div[style*="height: '500px'"] {
            height: 400px !important;
          }
          
          /* PRIMA Logo mobile */
          img[alt="PRIMA Logo"] {
            max-height: 180px !important;
            max-width: 90% !important;
          }
          
          /* Stats badges mobile */
          .about-stats > div {
            width: auto !important;
            min-width: 120px !important;
            max-width: none !important;
            padding: 10px 14px !important;
            font-size: 0.85rem !important;
          }
          
          /* Container max-width mobile */
          .container {
            padding-left: 10px !important;
            padding-right: 10px !important;
          }
        }
        
        @media (max-width: 480px) {
          /* Extra small screens */
          .about-section,
          .main-outcomes-section,
          .innovation-section,
          .objectives-section {
            padding: 30px 12px !important;
          }
          
          .about-cta-band {
            padding: 16px 12px !important;
          }
          
          /* Hero adjustments */
          .about-hero-content {
            padding: 16px !important;
          }
          div[style*="height: '400px'"] {
            height: 350px !important;
          }
          
          /* PRIMA Logo extra small */
          img[alt="PRIMA Logo"] {
            max-height: 140px !important;
            max-width: 85% !important;
          }
          
          /* Stats badges extra small */
          .about-stats {
            gap: 8px !important;
          }
          .about-stats > div {
            padding: 8px 12px !important;
            font-size: 0.8rem !important;
            min-width: 100px !important;
          }
          .about-stats span[style*="fontSize: '1.2rem'"] {
            font-size: 0.9rem !important;
          }
          .about-stats span[style*="fontSize: '1.1rem'"] {
            font-size: 0.95rem !important;
          }
        }
        
        /* Grid responsive */
        @media (max-width: 768px) {
          [style*="gridTemplateColumns"][style*="repeat(auto-fit"] {
            grid-template-columns: 1fr !important;
            gap: 20px !important;
          }
          
          /* Cards mobile */
          .about-card {
            padding: 24px 20px !important;
          }
          
          /* Card icons mobile */
          .about-card [style*="width: '56px'"],
          .about-card [style*="width: '52px'"] {
            width: 48px !important;
            height: 48px !important;
            font-size: 1.4rem !important;
          }
          
          /* Headings mobile */
          .about-card h3[style*="fontSize: '1.4rem'"],
          .about-card h3[style*="fontSize: '1.25rem'"] {
            font-size: 1.15rem !important;
          }
          
          /* Text mobile */
          .about-card p[style*="fontSize: '1.05rem'"],
          .about-card p[style*="fontSize: '1rem'"] {
            font-size: 0.95rem !important;
            line-height: 1.6 !important;
          }
          
          /* Badges mobile */
          [style*="borderRadius: '50px'"][style*="padding: '12px 24px'"] {
            padding: 10px 16px !important;
            font-size: 0.85rem !important;
          }
          
          /* Section headings mobile */
          h2[style*="fontSize: 'clamp(32px,5vw,48px)'"] {
            font-size: clamp(24px, 6vw, 32px) !important;
            margin-bottom: 12px !important;
          }
          
          /* Section text mobile */
          p[style*="fontSize: '1.15rem'"] {
            font-size: 1rem !important;
          }
        }
        
        @media (max-width: 480px) {
          /* Cards extra small */
          .about-card {
            padding: 20px 16px !important;
          }
          
          /* Card icons extra small */
          .about-card [style*="width: '48px'"] {
            width: 40px !important;
            height: 40px !important;
            font-size: 1.2rem !important;
          }
          
          /* Headings extra small */
          .about-card h3 {
            font-size: 1.05rem !important;
          }
        }
      `}</style>
      <div class="home page-template page-template-page-templates page-template-fullwidth-content page-template-page-templatesfullwidth-content-php page page-id-4059 jet-theme-core jet-theme-core--has-template jet-theme-core--has-header jet-theme-core--has-body jet-theme-core--has-footer layout-fullwidth blog-masonry elementor-default elementor-kit-5747 elementor-page elementor-page-4059"><div id="jet-theme-core-document" class="jet-theme-core-document jet-theme-core-document--elementor-content-type"><div class="jet-theme-core-document__inner">
	
	<Navbar/>
	
	{/* Composant de test des icônes FontAwesome */}
	
	<article id="post-4059" class="post-4059 page type-page status-publish hentry">	
			<div data-elementor-type="wp-page" data-elementor-id="4059" class="elementor elementor-4059">
				<section class="elementor-section elementor-top-section elementor-element elementor-element-ic2p76x elementor-section-full_width elementor-section-height-default elementor-section-height-default" data-id="ic2p76x" data-element_type="section" data-settings="{&quot;jet_parallax_layout_list&quot;:[{&quot;jet_parallax_layout_image&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;_id&quot;:&quot;5759a04&quot;,&quot;jet_parallax_layout_image_tablet&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_image_mobile&quot;:{&quot;url&quot;:&quot;&quot;,&quot;id&quot;:&quot;&quot;,&quot;size&quot;:&quot;&quot;},&quot;jet_parallax_layout_speed&quot;:{&quot;unit&quot;:&quot;%&quot;,&quot;size&quot;:50,&quot;sizes&quot;:[]},&quot;jet_parallax_layout_type&quot;:&quot;scroll&quot;,&quot;jet_parallax_layout_direction&quot;:null,&quot;jet_parallax_layout_fx_direction&quot;:null,&quot;jet_parallax_layout_z_index&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x&quot;:50,&quot;jet_parallax_layout_bg_x_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_x_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y&quot;:50,&quot;jet_parallax_layout_bg_y_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_y_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size&quot;:&quot;auto&quot;,&quot;jet_parallax_layout_bg_size_tablet&quot;:&quot;&quot;,&quot;jet_parallax_layout_bg_size_mobile&quot;:&quot;&quot;,&quot;jet_parallax_layout_animation_prop&quot;:&quot;transform&quot;,&quot;jet_parallax_layout_on&quot;:[&quot;desktop&quot;,&quot;tablet&quot;]}]}">
					<div class="elementor-container elementor-column-gap-default">
						<div class="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-im9c73l" data-id="im9c73l" data-element_type="column">
							<div class="elementor-widget-wrap elementor-element-populated">
								<div class="elementor-element elementor-element-0bd4fc3 elementor-widget elementor-widget-jet-slider" data-id="0bd4fc3" data-element_type="widget" data-settings="{&quot;slider_height&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:852,&quot;sizes&quot;:[]},&quot;_animation&quot;:&quot;none&quot;,&quot;slider_height_tablet&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:650,&quot;sizes&quot;:[]},&quot;slider_height_mobile&quot;:{&quot;unit&quot;:&quot;px&quot;,&quot;size&quot;:500,&quot;sizes&quot;:[]}}" data-widget_type="jet-slider.default">
									<div class="elementor-widget-container">
										<div class="elementor-jet-slider jet-elements">
											<div style={{ position: 'relative', width: '100%', height: '580px', overflow: 'hidden' }}>
												<img 
													src="https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" 
													alt="Sustainable urban agriculture - MedAgriCycle" 
													style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
												/>
												<div style={{ position: 'absolute', inset: 0, background: 'rgba(0, 0, 0, 0.45)' }} />
												<div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' }}>
													<div className="about-hero-content" style={{ padding: '24px 32px', maxWidth: '960px', width: '100%' }}>
														<h1 style={{ color: '#fff', fontSize: 'clamp(36px,7vw,64px)', fontWeight: 800, margin: 0, textAlign: 'center', letterSpacing: '-0.5px', textShadow: '0 2px 10px rgba(0,0,0,0.3)' }}>
                                                        {t('about.hero.title')}
                                                        </h1>
                                  <p style={{ color: 'rgba(255,255,255,0.98)', fontSize: 'clamp(18px,3vw,22px)', lineHeight: 1.7, margin: '16px auto 0', textAlign: 'center', maxWidth: '820px', fontWeight: 300 }}>
                                                        {t('about.hero.subtitle')}
                                                      </p>
                                  
                                  {/* PRIMA Logo in Hero */}
                                  <div style={{ marginTop: '24px', textAlign: 'center' }}>
                                    <img 
                                      alt="PRIMA Logo" 
                                      src={primaLogo}                                    
                                      style={{
                                        maxHeight: '260px',
                                        width: '100%',
                                        maxWidth: '520px',
                                        height: 'auto',
                                        objectFit: 'contain',
                                        filter: 'brightness(1.1)'
                                      }}
                                    />
                                  </div>

                                  {/* Stats under hero */}
                                  <div className="about-stats" style={{
                                    marginTop: '32px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '16px',
                                    flexWrap: 'wrap'
                                  }}>
                                    {[
                                      { label: t('about.stats.duration'), value: '2025-2028', icon: '📅' },
                                      { label: t('about.stats.partners'), value: partners.length > 0 ? partners.length.toString() : '10', icon: '🤝' },
                                      { label: t('about.stats.countries'), value: '6', icon: '🌍' }                                    ].map((item, idx) => (
                                      <div key={idx} style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '10px',
                                        padding: '12px 20px',
                                        background: 'rgba(255,255,255,0.15)',
                                        color: '#fff',
                                        border: '1px solid rgba(255,255,255,0.25)',
                                        borderRadius: '12px',
                                        backdropFilter: 'blur(8px)',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                        transition: 'all 0.3s ease'
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.background = 'rgba(255,255,255,0.25)';
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.background = 'rgba(255,255,255,0.15)';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                      }}
                                      >
                                        <span style={{ fontSize: '1.2rem' }}>{item.icon}</span>
                                        <div>
                                          <span style={{ display: 'block', opacity: .9, fontSize: '.75rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>{item.label}</span>
                                          <span style={{ display: 'block', fontWeight: 700, fontSize: '1.1rem', marginTop: '2px' }}>{item.value}</span>
                                        </div>
                                      </div>
                                    ))}
                                  </div>

                                                     
														
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            {/* Attention CTA Band */}
            <section className="about-cta-band" style={{ background: 'linear-gradient(135deg, #96ca2d 0%, #7ba818 100%)', color: '#0a2a0a', padding: '16px 20px', boxShadow: '0 4px 12px rgba(150,202,45,0.2)' }}>
              <div className="container about-cta-container" style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16, flexWrap: 'wrap' }}>
                <strong style={{ fontSize: 'clamp(12px,2.6vw,17px)', fontWeight: 700,  }}>{t('about.cta.text')}</strong>
                <Link to="/contact" style={{ background: '#0a2a0a',fontSize: 'clamp(12px,2.6vw,17px)', color: '#fff', padding: '6px 12px', borderRadius: '8px', textDecoration: 'none', fontWeight: 700, transition: 'all 0.3s ease', boxShadow: '0 2px 8px rgba(0,0,0,0.2)' }}
                   onMouseEnter={(e) => {
                     e.currentTarget.style.background = '#ffffff';
                     e.currentTarget.style.color = '#0a2a0a';
                     e.currentTarget.style.transform = 'translateY(-2px)';
                   }}
                   onMouseLeave={(e) => {
                     e.currentTarget.style.background = '#0a2a0a';
                     e.currentTarget.style.color = '#fff';
                     e.currentTarget.style.transform = 'translateY(0)';
                   }}
                >{t('about.cta.button')} <i className="fas fa-arrow-right" style={{ marginLeft: '8px' }}></i></Link>
              </div>
            </section>
            
            {/* Partners Carousel Section */}
            <section className="partners-carousel-section" style={{
              padding: 'clamp(60px, 8vw, 100px) 20px',
              background: '#ffffff',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
                <div style={{ textAlign: 'center', marginBottom: '50px' }}>
                  <h2 style={{
                    fontSize: 'clamp(28px, 4vw, 42px)',
                    fontWeight: 800,
                    color: '#1f2937',
                    marginBottom: '16px',
                    letterSpacing: '-0.5px'
                  }}>
                    {t('about.partners.title', 'Our Partners')}
                  </h2>
                  <div style={{ width: 80, height: 5, background: 'linear-gradient(90deg, #96ca2d 0%, #7ba818 100%)', borderRadius: 999, margin: '0 auto 24px' }} />
                  <p style={{
                    fontSize: '1.1rem',
                    color: '#495057',
                    maxWidth: '700px',
                    margin: '0 auto',
                    lineHeight: '1.75'
                  }}>
                    {t('about.partners.subtitle', 'Collaborating with leading institutions across the Mediterranean')}
                  </p>
                </div>

                {partnersLoading ? (
                  <div style={{ textAlign: 'center', padding: '60px 20px' }}>
                    <div style={{
                      display: 'inline-block',
                      width: '40px',
                      height: '40px',
                      border: '4px solid #f3f3f3',
                      borderTop: '4px solid #96ca2d',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }}></div>
                    <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                  </div>
                ) : partners.length > 0 ? (
                  <div style={{
                    position: 'relative',
                    width: '100%',
                    overflow: 'hidden',
                    padding: '20px 0'
                  }}>
                    <div className="partners-carousel-track" style={{
                      display: 'flex',
                      gap: '40px',
                      animation: 'scroll 30s linear infinite',
                      width: 'max-content'
                    }}>
                      {/* Duplicate partners for seamless loop */}
                      {[...partners, ...partners].map((partner, idx) => (
                        <div
                          key={`${partner._id || partner.id || idx}-${Math.floor(idx / partners.length)}`}
                          style={{
                            flexShrink: 0,
                            width: '220px',
                            height: 'auto',
                            minHeight: '200px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: '#ffffff',
                            borderRadius: '12px',
                            padding: '20px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                            border: '1px solid #e9ecef',
                            transition: 'all 0.3s ease',
                            cursor: partner.website && partner.website !== '#' ? 'pointer' : 'default'
                          }}
                          onMouseEnter={(e) => {
                            if (partner.website && partner.website !== '#') {
                              e.currentTarget.style.transform = 'translateY(-5px)';
                              e.currentTarget.style.boxShadow = '0 8px 20px rgba(150,202,45,0.2)';
                              e.currentTarget.style.borderColor = '#96ca2d';
                            }
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)';
                            e.currentTarget.style.borderColor = '#e9ecef';
                          }}
                          onClick={() => {
                            if (partner.website && partner.website !== '#' && partner.website !== '#') {
                              window.open(partner.website, '_blank', 'noopener,noreferrer');
                            }
                          }}
                        >
                          <div style={{
                            width: '100%',
                            height: '100px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginBottom: '16px'
                          }}>
                            {partner.logoUrl ? (
                              <img
                                src={getFileUrl(partner.logoUrl)}
                                alt={partner.name || 'Partner logo'}
                                style={{
                                  maxWidth: '100%',
                                  maxHeight: '100%',
                                  objectFit: 'contain',
                                  width: 'auto',
                                  height: 'auto'
                                }}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                  e.target.nextSibling.style.display = 'flex';
                                }}
                              />
                            ) : null}
                            <div style={{
                              display: partner.logoUrl ? 'none' : 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: '100%',
                              height: '100%',
                              fontSize: '3rem',
                              color: '#96ca2d'
                            }}>
                              🏢
                            </div>
                          </div>
                          <div style={{
                            width: '100%',
                            textAlign: 'center'
                          }}>
                            <h3 style={{
                              fontSize: '1rem',
                              fontWeight: 700,
                              color: '#1f2937',
                              margin: '0 0 10px 0',
                              lineHeight: '1.3',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              display: '-webkit-box',
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: 'vertical'
                            }}>
                              {partner.name || partner.fullName || 'Partner'}
                            </h3>
                            {partner.pi && (
                              <p style={{
                                fontSize: '0.9rem',
                                color: '#495057',
                                margin: 0,
                                fontWeight: 500,
                                lineHeight: '1.5',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical'
                              }}>
                                <span style={{ color: '#96ca2d', fontWeight: 700, fontSize: '0.85rem' }}>{t('about.partners.pi', 'PI')}: </span>
                                <span style={{ color: '#495057' }}>{partner.pi}</span>
                              </p>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                    <style>{`
                      @keyframes scroll {
                        0% { transform: translateX(0); }
                        100% { transform: translateX(calc(-220px * ${partners.length} - 40px * ${partners.length})); }
                      }
                      @media (max-width: 768px) {
                        .partners-carousel-track > div {
                          width: 180px !important;
                          min-height: 180px !important;
                          padding: 15px !important;
                        }
                        .partners-carousel-track > div > div:first-child {
                          height: 80px !important;
                          margin-bottom: 12px !important;
                        }
                        .partners-carousel-track > div h3 {
                          font-size: 0.9rem !important;
                        }
                        .partners-carousel-track > div p {
                          font-size: 0.75rem !important;
                        }
                        @keyframes scroll {
                          0% { transform: translateX(0); }
                          100% { transform: translateX(calc(-180px * ${partners.length} - 30px * ${partners.length})); }
                        }
                      }
                      @media (max-width: 480px) {
                        .partners-carousel-track > div {
                          width: 160px !important;
                          min-height: 160px !important;
                          padding: 12px !important;
                        }
                        .partners-carousel-track > div > div:first-child {
                          height: 70px !important;
                          margin-bottom: 10px !important;
                        }
                        .partners-carousel-track > div h3 {
                          font-size: 0.85rem !important;
                        }
                        .partners-carousel-track > div p {
                          font-size: 0.7rem !important;
                        }
                        @keyframes scroll {
                          0% { transform: translateX(0); }
                          100% { transform: translateX(calc(-160px * ${partners.length} - 24px * ${partners.length})); }
                        }
                      }
                    `}</style>
                  </div>
                ) : (
                  <div style={{ textAlign: 'center', padding: '60px 20px', color: '#6c757d' }}>
                    <p>{t('about.partners.noPartners', 'No partners available')}</p>
                  </div>
                )}
              </div>
            </section>
            </div>
          </article>
          
      {/* About Section */}
      <section className="about-section fade-up" style={{
        padding: 'clamp(60px, 8vw, 100px) 20px',
        background: '#f0f7e6',
        position: 'relative'
      }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          
          <div style={{
            maxWidth: '900px',
            margin: '0 auto',
            textAlign: 'center'
          }}>
            
            <div style={{ marginBottom: '40px' }}>
              <h2 style={{ fontSize: 'clamp(32px,5vw,48px)', fontWeight: 800, color: '#1f2937', margin: '0 0 20px 0', letterSpacing: '-0.5px' }}>{t('about.section.title')}</h2>
              <div style={{ width: 80, height: 5, background: 'linear-gradient(90deg, #96ca2d 0%, #7ba818 100%)', borderRadius: 999, margin: '0 auto 32px' }} />
              <div style={{ fontSize: '1.15rem', lineHeight: 1.85, color: '#495057', textAlign: 'left', maxWidth: '800px', margin: '0 auto' }}>
                <p style={{ margin: '0 0 20px 0', fontSize: '1.1rem' }}>
                  {t('about.section.description1')}
                </p>
                <p style={{ margin: 0, fontSize: '1.1rem' }}>
                  {t('about.section.description2')}
                </p>
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 32, justifyContent: 'center' }}>
                {[t('about.section.badges.sustainableAgriculture'), t('about.section.badges.circularEconomy'), t('about.section.badges.mediterraneanFocus')].map((txt) => (
                  <div key={txt} style={{ 
                    display: 'inline-flex', 
                    alignItems: 'center', 
                    gap: 10, 
                    background: '#ffffff', 
                    color: '#495057', 
                    padding: '10px 20px', 
                    borderRadius: '50px', 
                    border: '2px solid #96ca2d', 
                    fontSize: '1rem',
                    fontWeight: 600,
                    boxShadow: '0 2px 8px rgba(150,202,45,0.15)',
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#96ca2d';
                    e.currentTarget.style.color = '#fff';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(150,202,45,0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = '#ffffff';
                    e.currentTarget.style.color = '#495057';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 2px 8px rgba(150,202,45,0.15)';
                  }}
                  >
                    <span style={{ color: '#96ca2d', fontSize: '1.1rem' }}>✓</span>
                    <span>{txt}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Outcomes Section */}
      <section className="main-outcomes-section fade-up" style={{
        padding: 'clamp(60px, 8vw, 100px) 20px',
        position: 'relative'
      }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '12px',
              background: 'linear-gradient(135deg, #f0f7e6 0%, #e8f4d9 100%)',
              padding: '12px 24px',
              borderRadius: '50px',
              marginBottom: '28px',
              fontSize: '0.95rem',
              color: '#2d5016',
              fontWeight: '600',
              border: '1px solid rgba(150,202,45,0.2)',
              boxShadow: '0 2px 8px rgba(150,202,45,0.1)'
            }}>
              <div style={{
                width: '10px',
                height: '10px',
                background: '#96ca2d',
                borderRadius: '50%',
                boxShadow: '0 0 8px rgba(150,202,45,0.5)'
              }}></div>
              {t('about.outcomes.badge')}
            </div>
            
            <h2 style={{
              fontSize: 'clamp(32px,5vw,48px)',
              fontWeight: '800',
              color: '#1f2937',
              marginBottom: '16px',
              lineHeight: '1.2',
              letterSpacing: '-0.5px'
            }}>
              {t('about.outcomes.title')}
            </h2>
            <div style={{ width: 80, height: 5, background: 'linear-gradient(90deg, #96ca2d 0%, #7ba818 100%)', borderRadius: 999, margin: '0 auto 24px' }} />
            
            <p style={{
              fontSize: '1.15rem',
              color: '#495057',
              maxWidth: '700px',
              margin: '0 auto',
              lineHeight: '1.75',
              fontWeight: 400
            }}>
              {t('about.outcomes.subtitle')}
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '24px'
          }}>
            
            <div 
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 12px 24px rgba(150,202,45,0.2)'; e.currentTarget.style.borderColor = '#96ca2d'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'; e.currentTarget.style.borderColor = '#e9ecef'; }}
            className="fade-up about-card"
            style={{
              background: '#ffffff', borderRadius: '16px', padding: '36px', border: '2px solid #e9ecef', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease', animationDelay: '.1s', cursor: 'pointer'
            }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '18px',
                marginBottom: '24px'
              }}>
                <div style={{
                  width: '56px',
                  height: '56px',
                  background: 'linear-gradient(135deg, #96ca2d 0%, #7ba818 100%)',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.8rem',
                  color: 'white',
                  boxShadow: '0 4px 12px rgba(150,202,45,0.3)'
                }}>♻️</div>
                <h3 style={{
                  fontSize: '1.4rem',
                  fontWeight: '700',
                  color: '#1f2937',
                  margin: 0,
                  letterSpacing: '-0.3px'
                }}>
                  {t('about.outcomes.circularEconomy.title')}
                </h3>
              </div>
              <p style={{
                fontSize: '1.05rem',
                color: '#495057',
                lineHeight: '1.75',
                margin: 0,
                fontWeight: 400
              }}>
                {t('about.outcomes.circularEconomy.description')}
              </p>
            </div>

            <div 
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 12px 24px rgba(52,152,219,0.2)'; e.currentTarget.style.borderColor = '#3498db'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'; e.currentTarget.style.borderColor = '#e9ecef'; }}
            className="fade-up about-card"
            style={{
              background: '#ffffff', borderRadius: '16px', padding: '36px', border: '2px solid #e9ecef', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease', animationDelay: '.2s', cursor: 'pointer'
            }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '18px',
                marginBottom: '24px'
              }}>
                <div style={{
                  width: '56px',
                  height: '56px',
                  background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.8rem',
                  color: 'white',
                  boxShadow: '0 4px 12px rgba(52,152,219,0.3)'
                }}>🧬</div>
                <h3 style={{
                  fontSize: '1.4rem',
                  fontWeight: '700',
                  color: '#1f2937',
                  margin: 0,
                  letterSpacing: '-0.3px'
                }}>
                  {t('about.outcomes.scientificInnovation.title')}
                </h3>
              </div>
              <p style={{
                fontSize: '1.05rem',
                color: '#495057',
                lineHeight: '1.75',
                margin: 0,
                fontWeight: 400
              }}>
                {t('about.outcomes.scientificInnovation.description')}
              </p>
            </div>

            <div 
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 12px 24px rgba(155,89,182,0.2)'; e.currentTarget.style.borderColor = '#9b59b6'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'; e.currentTarget.style.borderColor = '#e9ecef'; }}
            className="fade-up about-card"
            style={{
              background: '#ffffff', borderRadius: '16px', padding: '36px', border: '2px solid #e9ecef', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease', animationDelay: '.3s', cursor: 'pointer'
            }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '18px',
                marginBottom: '24px'
              }}>
                <div style={{
                  width: '56px',
                  height: '56px',
                  background: 'linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%)',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.8rem',
                  color: 'white',
                  boxShadow: '0 4px 12px rgba(155,89,182,0.3)'
                }}>🏙️</div>
                <h3 style={{
                  fontSize: '1.4rem',
                  fontWeight: '700',
                  color: '#1f2937',
                  margin: 0,
                  letterSpacing: '-0.3px'
                }}>
                  {t('about.outcomes.urbanResilience.title')}
                </h3>
              </div>
              <p style={{
                fontSize: '1.05rem',
                color: '#495057',
                lineHeight: '1.75',
                margin: 0,
                fontWeight: 400
              }}>
                {t('about.outcomes.urbanResilience.description')}
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* Innovation & Technology */}
      <section className="innovation-section fade-up" style={{
        padding: 'clamp(60px, 8vw, 100px) 20px',
        background: '#f0f7e6',
        position: 'relative'
      }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '12px',
              background: 'linear-gradient(135deg, #f0f7e6 0%, #e8f4d9 100%)',
              padding: '12px 24px',
              borderRadius: '50px',
              marginBottom: '28px',
              fontSize: '0.95rem',
              color: '#2d5016',
              fontWeight: '600',
              border: '1px solid rgba(150,202,45,0.2)',
              boxShadow: '0 2px 8px rgba(150,202,45,0.1)'
            }}>
              <div style={{
                width: '10px',
                height: '10px',
                background: '#96ca2d',
                borderRadius: '50%',
                boxShadow: '0 0 8px rgba(150,202,45,0.5)'
              }}></div>
              {t('about.innovation.badge')}
            </div>
            
            <h2 style={{
              fontSize: 'clamp(32px,5vw,48px)',
              fontWeight: '800',
              color: '#1f2937',
              marginBottom: '16px',
              lineHeight: '1.2',
              letterSpacing: '-0.5px'
            }}>
              {t('about.innovation.title')}
            </h2>
            <div style={{ width: 80, height: 5, background: 'linear-gradient(90deg, #96ca2d 0%, #7ba818 100%)', borderRadius: 999, margin: '0 auto 24px' }} />
            
            <p style={{
              fontSize: '1.15rem',
              color: '#495057',
              maxWidth: '700px',
              margin: '0 auto',
              lineHeight: '1.75',
              fontWeight: 400
            }}>
              {t('about.innovation.subtitle')}
            </p>
          </div>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '24px'
          }}>
            
            <div 
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 12px 24px rgba(102,126,234,0.2)'; e.currentTarget.style.borderColor = '#667eea'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'; e.currentTarget.style.borderColor = '#e9ecef'; }}
            className="fade-up about-card"
            style={{
              background: '#ffffff', borderRadius: '16px', padding: '36px', border: '2px solid #e9ecef', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease', animationDelay: '.1s', cursor: 'pointer'
            }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '18px',
                marginBottom: '24px'
              }}>
                <div style={{
                  width: '56px',
                  height: '56px',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.8rem',
                  color: 'white',
                  boxShadow: '0 4px 12px rgba(102,126,234,0.3)'
                }}>💧</div>
                <h3 style={{
                  fontSize: '1.4rem',
                  fontWeight: '700',
                  color: '#1f2937',
                  margin: 0,
                  letterSpacing: '-0.3px'
                }}>
                  {t('about.innovation.waterManagement.title')}
                </h3>
              </div>
              <p style={{
                fontSize: '1.05rem',
                color: '#495057',
                lineHeight: '1.75',
                margin: 0,
                fontWeight: 400
              }}>
                {t('about.innovation.waterManagement.description')}
              </p>
            </div>

            <div 
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 12px 24px rgba(52,152,219,0.2)'; e.currentTarget.style.borderColor = '#3498db'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'; e.currentTarget.style.borderColor = '#e9ecef'; }}
            className="fade-up about-card"
            style={{
              background: '#ffffff', borderRadius: '16px', padding: '36px', border: '2px solid #e9ecef', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease', animationDelay: '.2s', cursor: 'pointer'
            }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '18px',
                marginBottom: '24px'
              }}>
                <div style={{
                  width: '56px',
                  height: '56px',
                  background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.8rem',
                  color: 'white',
                  boxShadow: '0 4px 12px rgba(52,152,219,0.3)'
                }}>🧬</div>
                <h3 style={{
                  fontSize: '1.4rem',
                  fontWeight: '700',
                  color: '#1f2937',
                  margin: 0,
                  letterSpacing: '-0.3px'
                }}>
                  {t('about.innovation.proteinExtraction.title')}
                </h3>
              </div>
              <p style={{
                fontSize: '1.05rem',
                color: '#495057',
                lineHeight: '1.75',
                margin: 0,
                fontWeight: 400
              }}>
                {t('about.innovation.proteinExtraction.description')}
              </p>
            </div>

            <div 
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 12px 24px rgba(155,89,182,0.2)'; e.currentTarget.style.borderColor = '#9b59b6'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'; e.currentTarget.style.borderColor = '#e9ecef'; }}
            className="fade-up about-card"
            style={{
              background: '#ffffff', borderRadius: '16px', padding: '36px', border: '2px solid #e9ecef', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease', animationDelay: '.3s', cursor: 'pointer'
            }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '18px',
                marginBottom: '24px'
              }}>
                <div style={{
                  width: '56px',
                  height: '56px',
                  background: 'linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%)',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.8rem',
                  color: 'white',
                  boxShadow: '0 4px 12px rgba(155,89,182,0.3)'
                }}>💻</div>
                <h3 style={{
                  fontSize: '1.4rem',
                  fontWeight: '700',
                  color: '#1f2937',
                  margin: 0,
                  letterSpacing: '-0.3px'
                }}>
                  {t('about.innovation.digitalSolutions.title')}
                </h3>
              </div>
              <p style={{
                fontSize: '1.05rem',
                color: '#495057',
                lineHeight: '1.75',
                margin: 0,
                fontWeight: 400
              }}>
                {t('about.innovation.digitalSolutions.description')}
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* Key Objectives */}
      <section className="objectives-section fade-up" style={{
        padding: 'clamp(60px, 8vw, 100px) 20px',
        position: 'relative'
      }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <div style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '12px',
              background: 'linear-gradient(135deg, #f0f7e6 0%, #e8f4d9 100%)',
              padding: '12px 24px',
              borderRadius: '50px',
              marginBottom: '28px',
              fontSize: '0.95rem',
              color: '#2d5016',
              fontWeight: '600',
              border: '1px solid rgba(150,202,45,0.2)',
              boxShadow: '0 2px 8px rgba(150,202,45,0.1)'
            }}>
              <div style={{
                width: '10px',
                height: '10px',
                background: '#96ca2d',
                borderRadius: '50%',
                boxShadow: '0 0 8px rgba(150,202,45,0.5)'
              }}></div>
              {t('about.objectives.badge')}
            </div>
            
            <h2 style={{
              fontSize: 'clamp(32px,5vw,48px)',
              fontWeight: '800',
              color: '#1f2937',
              marginBottom: '16px',
              lineHeight: '1.2',
              letterSpacing: '-0.5px'
            }}>
              {t('about.objectives.title')}
            </h2>
            <div style={{ width: 80, height: 5, background: 'linear-gradient(90deg, #96ca2d 0%, #7ba818 100%)', borderRadius: 999, margin: '0 auto 24px' }} />
            
            <p style={{
              fontSize: '1.15rem',
              color: '#495057',
              maxWidth: '700px',
              margin: '0 auto',
              lineHeight: '1.75',
              fontWeight: 400
            }}>
              {t('about.objectives.subtitle')}
            </p>
          </div>
          
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '24px'
          }}>
            
            <div 
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 12px 24px rgba(150,202,45,0.2)'; e.currentTarget.style.borderColor = '#96ca2d'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'; e.currentTarget.style.borderColor = '#e9ecef'; }}
            className="fade-up about-card"
            style={{
              background: '#ffffff', borderRadius: '16px', padding: '32px', border: '2px solid #e9ecef', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease', animationDelay: '.1s', cursor: 'pointer'
            }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                marginBottom: '20px'
              }}>
                <div style={{
                  width: '52px',
                  height: '52px',
                  background: 'linear-gradient(135deg, #96ca2d 0%, #7ba818 100%)',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.6rem',
                  color: 'white',
                  boxShadow: '0 4px 12px rgba(150,202,45,0.3)'
                }}>💧</div>
                <h3 style={{
                  fontSize: '1.25rem',
                  fontWeight: '700',
                  color: '#1f2937',
                  margin: 0,
                  letterSpacing: '-0.3px'
                }}>
                  {t('about.objectives.waterResourceManagement.title')}
                </h3>
              </div>
              <p style={{
                fontSize: '1rem',
                color: '#495057',
                lineHeight: '1.7',
                margin: 0,
                fontWeight: 400
              }}>
                {t('about.objectives.waterResourceManagement.description')}
              </p>
            </div>

            <div 
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 12px 24px rgba(52,152,219,0.2)'; e.currentTarget.style.borderColor = '#3498db'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'; e.currentTarget.style.borderColor = '#e9ecef'; }}
            className="fade-up about-card"
            style={{
              background: '#ffffff', borderRadius: '16px', padding: '32px', border: '2px solid #e9ecef', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease', animationDelay: '.15s', cursor: 'pointer'
            }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                marginBottom: '20px'
              }}>
                <div style={{
                  width: '52px',
                  height: '52px',
                  background: 'linear-gradient(135deg, #3498db 0%, #2980b9 100%)',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.6rem',
                  color: 'white',
                  boxShadow: '0 4px 12px rgba(52,152,219,0.3)'
                }}>♻️</div>
                <h3 style={{
                  fontSize: '1.25rem',
                  fontWeight: '700',
                  color: '#1f2937',
                  margin: 0,
                  letterSpacing: '-0.3px'
                }}>
                  {t('about.objectives.wasteRecycling.title')}
                </h3>
              </div>
              <p style={{
                fontSize: '1rem',
                color: '#495057',
                lineHeight: '1.7',
                margin: 0,
                fontWeight: 400
              }}>
                {t('about.objectives.wasteRecycling.description')}
              </p>
            </div>

            <div 
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 12px 24px rgba(155,89,182,0.2)'; e.currentTarget.style.borderColor = '#9b59b6'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'; e.currentTarget.style.borderColor = '#e9ecef'; }}
            className="fade-up about-card"
            style={{
              background: '#ffffff', borderRadius: '16px', padding: '32px', border: '2px solid #e9ecef', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease', animationDelay: '.2s', cursor: 'pointer'
            }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                marginBottom: '20px'
              }}>
                <div style={{
                  width: '52px',
                  height: '52px',
                  background: 'linear-gradient(135deg, #9b59b6 0%, #8e44ad 100%)',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.6rem',
                  color: 'white',
                  boxShadow: '0 4px 12px rgba(155,89,182,0.3)'
                }}>🧬</div>
                <h3 style={{
                  fontSize: '1.25rem',
                  fontWeight: '700',
                  color: '#1f2937',
                  margin: 0,
                  letterSpacing: '-0.3px'
                }}>
                  {t('about.objectives.proteinExtraction.title')}
                </h3>
              </div>
              <p style={{
                fontSize: '1rem',
                color: '#495057',
                lineHeight: '1.7',
                margin: 0,
                fontWeight: 400
              }}>
                {t('about.objectives.proteinExtraction.description')}
              </p>
            </div>

            <div 
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 12px 24px rgba(231,76,60,0.2)'; e.currentTarget.style.borderColor = '#e74c3c'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'; e.currentTarget.style.borderColor = '#e9ecef'; }}
            className="fade-up about-card"
            style={{
              background: '#ffffff', borderRadius: '16px', padding: '32px', border: '2px solid #e9ecef', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease', animationDelay: '.25s', cursor: 'pointer'
            }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                marginBottom: '20px'
              }}>
                <div style={{
                  width: '52px',
                  height: '52px',
                  background: 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.6rem',
                  color: 'white',
                  boxShadow: '0 4px 12px rgba(231,76,60,0.3)'
                }}>🍃</div>
                <h3 style={{
                  fontSize: '1.25rem',
                  fontWeight: '700',
                  color: '#1f2937',
                  margin: 0,
                  letterSpacing: '-0.3px'
                }}>
                  {t('about.objectives.foodIngredients.title')}
                </h3>
              </div>
              <p style={{
                fontSize: '1rem',
                color: '#495057',
                lineHeight: '1.7',
                margin: 0,
                fontWeight: 400
              }}>
                {t('about.objectives.foodIngredients.description')}
              </p>
            </div>

            <div 
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 12px 24px rgba(243,156,18,0.2)'; e.currentTarget.style.borderColor = '#f39c12'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'; e.currentTarget.style.borderColor = '#e9ecef'; }}
            className="fade-up about-card"
            style={{
              background: '#ffffff', borderRadius: '16px', padding: '32px', border: '2px solid #e9ecef', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease', animationDelay: '.3s', cursor: 'pointer'
            }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                marginBottom: '20px'
              }}>
                <div style={{
                  width: '52px',
                  height: '52px',
                  background: 'linear-gradient(135deg, #f39c12 0%, #e67e22 100%)',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.6rem',
                  color: 'white',
                  boxShadow: '0 4px 12px rgba(243,156,18,0.3)'
                }}>🏛️</div>
                <h3 style={{
                  fontSize: '1.25rem',
                  fontWeight: '700',
                  color: '#1f2937',
                  margin: 0,
                  letterSpacing: '-0.3px'
                }}>
                  {t('about.objectives.policyDevelopment.title')}
                </h3>
              </div>
              <p style={{
                fontSize: '1rem',
                color: '#495057',
                lineHeight: '1.7',
                margin: 0,
                fontWeight: 400
              }}>
                {t('about.objectives.policyDevelopment.description')}
              </p>
            </div>

            <div 
            onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 12px 24px rgba(26,188,156,0.2)'; e.currentTarget.style.borderColor = '#1abc9c'; }}
            onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.08)'; e.currentTarget.style.borderColor = '#e9ecef'; }}
            className="fade-up about-card"
            style={{
              background: '#ffffff', borderRadius: '16px', padding: '32px', border: '2px solid #e9ecef', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', transition: 'all 0.3s ease', animationDelay: '.35s', cursor: 'pointer'
            }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                marginBottom: '20px'
              }}>
                <div style={{
                  width: '52px',
                  height: '52px',
                  background: 'linear-gradient(135deg, #1abc9c 0%, #16a085 100%)',
                  borderRadius: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '1.6rem',
                  color: 'white',
                  boxShadow: '0 4px 12px rgba(26,188,156,0.3)'
                }}>💻</div>
                <h3 style={{
                  fontSize: '1.25rem',
                  fontWeight: '700',
                  color: '#1f2937',
                  margin: 0,
                  letterSpacing: '-0.3px'
                }}>
                  {t('about.objectives.digitalPlatform.title')}
                </h3>
              </div>
              <p style={{
                fontSize: '1rem',
                color: '#495057',
                lineHeight: '1.7',
                margin: 0,
                fontWeight: 400
              }}>
                {t('about.objectives.digitalPlatform.description')}
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
      </div></div></div>
    </>
  );
};

export default About;